import api from './api';
import authHeader from './auth-header'; // authHeader is not used if 'api' is configured with interceptors

const getPendingRequests = () => {
    return api.get('/admin/requests');
};

const approveRequest = (id) => {
    return api.post(`/admin/requests/${id}/approve`);
};

const rejectRequest = (id) => {
    return api.post(`/admin/requests/${id}/reject`);
};

const RequestService = {
    getPendingRequests,
    approveRequest,
    rejectRequest,
};

export default RequestService; 